<template>
  <v-app style="scr">    
      <div v-if="headInfo" class="head-info">
        <v-container fluid fill-height pa-0>        
          <v-layout row align-center justify-space-between>
            <blockquote class="blockquote black--text  text--lighten-2">
              {{ $t('message.head_info') }}
              <!-- Olá caro usuário, informamos que o <strong>InoBram Cloud</strong> passou por atualizações e melhorias, caso você tenha algum problema ao acessar sua conta, entre em contato com nosso Setor de Atendimento ao Cliente. -->
            </blockquote>
            <v-btn
              icon
              @click="headInfo = false"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-layout>
        </v-container>
      </div>
    <v-content class="background_pattern">      
      <v-container fluid fill-height>        
        <v-layout column justify-center align-center>
          <v-spacer></v-spacer>
          <div class="inobram-logo">
            <v-img
              alt="InoBram logo"
              width="198"
              height="48"
              src="/static/img/inobram-logo.svg">
            </v-img>
          </div>
          <v-flex row xs12 sm8 md4 class="minimal-width">
            <v-card class="rounded-edge">
              <v-form
                @submit.prevent="onSignin(username, password, accepted_consent_term)"
                class="white--text ma-1 pa-4 form-size"
                ref="signinForm"
                lazy-validation
              >
                <div v-if="errorMessage" class="mb-3">
                  <v-alert :value="errorMessage" outline type="warning" class="rounded-edge">
                    {{ $t(errorMessage) }}
                  </v-alert>
                </div>
                <div class="mb-4">
                  <v-img 
                    src="/static/img/inobram-cloud.svg"
                  >
                  </v-img>                
                </div>
                <v-text-field
                  :placeholder="$t('message.username')"
                  type="text"
                  v-model="username"
                  :maxlength="30"
                  :rules="usernameRules"
                  required
                >
                </v-text-field>
                <v-text-field
                  :placeholder="$t('message.password')"
                  :rules="passwordRules"
                  v-model="password"
                  :maxlength="30"
                  :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                  @click:append="showPassword = !showPassword"
                  :type="showPassword ? 'text' : 'password'"
                  required
                >
                </v-text-field>

                <v-checkbox
                  v-model="accepted_consent_term"
                  color="inobram_base_color"
                  :rules="acceptedConsentTermRules"
                  required  
                  v-show="userNeedsAcceptConsentTerm"                
                >
                  <template v-slot:label>              
                    <div @click.stop="" style="max-width: 300px;">
                      <span>
                        {{ $t("message.consent_term_question") }} <app-consent-term-dialog></app-consent-term-dialog>
                      </span>
                    </div>
                  </template>
                </v-checkbox>                

                <v-card-actions class="mt-3 mb-2 pa-0">
                  <v-btn
                    dark
                    round
                    depressed
                    :loading="signinLoading && !error"
                    type="submit"
                    class="ml-0 inobram_base_color_accent"
                    style="width:45%"
                  >
                    {{ $t('message.enter') }}
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    round
                    depressed
                    @click.native="goToOnSignUp()"
                    class="grey--text text--darken-2 ml-0"                
                    style="width:45%"
                  >
                    {{ $t('message.new_user') }}
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
            
            <div class="text-xs-center mt-4">
              <span
                class="use-hand-cursor my-link"
                @click="goToResetPassword()"
              >
                {{ $t('message.reset_password_question') }}
              </span>
            </div>
            <div class="text-xs-center mt-3">
              <div style="height:36px;" />
              <app-whatsapp-support-link></app-whatsapp-support-link>
            </div>

          </v-flex>
          <v-spacer></v-spacer>
          <app-footer></app-footer>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import Footer from '../../components/Footer/Footer'
import WhatsAppSupportLink from '../../components/WhatsAppSupport/WhatsAppSupportLink'
import ConsentTermDialog from '../../components/ConsentTerm/ConsentTermDialog'

export default {
  components: {
    'app-footer': Footer,
    'app-whatsapp-support-link': WhatsAppSupportLink,
    'app-consent-term-dialog': ConsentTermDialog
  },
  data() {
    return {
      headInfo: true,
      showPassword: false,
      signinLoading: false,
      username: '',
      password: '',
      accepted_consent_term: false,
      usernameRules: null,
      passwordRules: null,
      acceptedConsentTermRules: null
    }
  },
  computed: {
    ...mapGetters({
      session: 'session',
      error: 'error',
      locale: 'language',
      userNeedsAcceptConsentTerm: 'userNeedsAcceptConsentTerm'
    }),
    errorMessage() {
      if (this.error) {
        return this.error.data ? this.error.data.error : 'unknown error'
      }
      return null
    }
  },
  watch: {
    locale(v) {
      this.resetForm()
      this.createRules()
    }
  },
  created() {
    this.$store.dispatch('clearError')
    this.createRules()
  },
  methods: {
    createRules() {
      this.usernameRules = [v => !!v || this.$t('message.username_is_required')]
      this.passwordRules = [v => !!v || this.$t('message.password_is_required')]
      this.acceptedConsentTermRules = [
        v => {
          if (!this.userNeedsAcceptConsentTerm) {
            return true
          }
          return !!v || this.$t('You must agree to continue')
        }
      ]
    },
    resetForm() {
      this.$refs.signinForm.reset()
    },
    validateForm() {
      if (this.$refs.signinForm.validate()) {
        return true
      }
      return false
    },
    onSignin(username, password, acceptedConsentTerm) {
      if (this.validateForm()) {
        this.$store.dispatch('clearNotification')
        this.signinLoading = true

        let payload = {
          username,
          password
        }

        if (this.userNeedsAcceptConsentTerm) {
          payload = {
            ...payload,
            accepted_consent_term: acceptedConsentTerm
          }
        }

        this.$store
          .dispatch('session', payload)
          .then(result => {
            if (this.$route.query.redirect) {
              this.$router.push(this.$route.query.redirect)
            } else {
              this.$router.push('/products')
            }
          })
          .catch(err => console.log(err))
          .finally(() => {
            this.signinLoading = false
          })
      }
    },
    goToOnSignUp() {
      this.$router.push('/signup')
    },
    goToResetPassword() {
      this.$router.push('/resetpassword')
    }
  }
}
</script>

<style scoped>
@media (min-width: 601px) {
  .form-size {
    min-width: 400px;
  }
}

@media (max-width: 600px) {
  .minimal-width {
    width: 100%;
  }
}

.my-link {
  font-size: 16px;
  color: #fff;
}

.my-link:hover {
  /* color: #a2c745; */
  color: #babec5;
}

.inobram-logo {
  padding: 10px;
  margin-bottom: 36px;
}

</style>



// WEBPACK FOOTER //
// src/views/Auth/Signin.vue